'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function createCache() {
  var __cache = new Map();

  var setValue = function setValue(key, value) {
    // NoteReview(simon): ...
    if (value === null || value === undefined) {
      return;
    }

    __cache.set(key, value);
  };

  var getValue = function getValue(key, defaultValue) {
    var val = __cache.get(key);

    if (val === null || val === undefined) {
      return defaultValue;
    }

    return val;
  };

  var hasKey = function hasKey(key) {
    return __cache.has(key);
  };

  var deleteKey = function deleteKey(key) {
    return __cache["delete"](key);
  };

  var dumpAll = function dumpAll() {
    var dumped = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __cache.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];

        dumped[key] = value;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return dumped;
  };

  var loadAll = function loadAll(dump) {
    for (var _i = 0, _Object$entries = Object.entries(dump); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      setValue(key, value);
    }
  };

  var clearAll = function clearAll() {
    __cache.clear();
  };

  return {
    setValue: setValue,
    hasKey: hasKey,
    deleteKey: deleteKey,
    getValue: getValue,
    dumpAll: dumpAll,
    loadAll: loadAll,
    clearAll: clearAll
  };
}

function createAppCache() {
  // any: we don't care about typing this local variable
  var __cache = new Map();

  function setCache(key, cache) {
    __cache.set(key, cache);
  }

  function getCache(key) {
    return __cache.get(key);
  }

  function getOrCreateCache(key) {
    var inst = __cache.get(key);

    if (inst) {
      return inst;
    }

    var newInst = createCache();

    __cache.set(key, newInst);

    return newInst;
  }

  function dumpAll() {
    var dumped = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __cache.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];

        dumped[key] = value.dumpAll();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return dumped;
  }

  function loadAll(dump) {
    for (var _i = 0, _Object$entries = Object.entries(dump); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      var inner = getOrCreateCache(key);
      inner.loadAll(value);
    }
  }

  function clearAll() {
    __cache.clear();
  }

  return {
    setCache: setCache,
    getCache: getCache,
    createCache: createCache,
    getOrCreateCache: getOrCreateCache,
    dumpAll: dumpAll,
    loadAll: loadAll,
    clearAll: clearAll
  };
}

exports.createAppCache = createAppCache;
exports.createCache = createCache;
